import { useMutation } from "@apollo/client";
import {
  CreateProductPreferencesDocument,
  ItemShadeType,
  UpdateProductPreferencesDocument,
} from "/@/generated/graphql";

export const useProductPreferenceApi = () => {
  const [updateProductPreferencesMutation] = useMutation(
    UpdateProductPreferencesDocument
  );
  const [createProductPreferencesMutation] = useMutation(
    CreateProductPreferencesDocument
  );

  return {
    create: async (userId: string, shadeType?: ItemShadeType) =>
      await createProductPreferencesMutation({
        variables: {
          args: {
            dentist: {
              connect: {
                id: userId,
              },
            },
            shadeType,
          },
        },
      }),
    update: async (preferenceId: string, shadeType?: ItemShadeType) =>
      await updateProductPreferencesMutation({
        variables: {
          where: {
            id: preferenceId,
          },
          data: {
            shadeType: shadeType
              ? {
                  set: shadeType,
                }
              : undefined,
          },
        },
      }),
  };
};
